import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/src_jiraBusinessOverviewCalendarQuery$parameters';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const overviewCalendarEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-business-overview-calendar-entrypoint" */ './src'),
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => {
		return {
			queries: {
				overviewCalendarQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
